import { render, staticRenderFns } from "./files.vue?vue&type=template&id=745378b0"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"
import style0 from "./files.vue?vue&type=style&index=0&id=745378b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./files.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports